import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';
import { GoPrintService } from '@go-modules/services/go-print/go-print.service';

export const ngxGoPrintServiceModule = angular.module('ngxGoPrintServiceModule', [])
	.factory('ngxGoPrintService', downgradeInjectable(GoPrintService) as any)
	.name;
